import { Post } from 'api/index'

export const ELEMENT_SAVE_ELEMENT = 'ELEMENT_SAVE_ELEMENT'

export const saveElement = body => dispatch => {
  const host = window.location.host
  const url = host?.includes('staging')
    ? `${process.env.REACT_APP_STAGING_API_URL}/api/reports/save_element/`
    : `${process.env.REACT_APP_API_URL}/api/reports/save_element/`
  return dispatch({
    type: ELEMENT_SAVE_ELEMENT,
    payload: Post(url, JSON.stringify(body))
  })
}
